import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { Box } from "@mui/material";
import { selectCurrentCompany } from "../../../../../../../../redux/features/user/selectors/userState.selectors";
import { useAppSelector } from "../../../../../../../../redux/hooks/redux";
import { formatDate } from "../../../../../../../../utils";
import { formatCompanyInstant } from "../../../../../utils/companyWallTime";
import { getStatusPalette } from "../../helpers/normalizedColorsCalendar";

export const EventItem = ({ arg }) => {
  const {
    extendedProps: { status, quote, jobId, client, coverageArea },
    start,
    end,
  } = arg.event;

  const currentCompany = useAppSelector(selectCurrentCompany);
  const companyTimeZone = currentCompany?.timeZone || "UTC";

  const palette = getStatusPalette(status);

  const clientName = client?.name || `${client?.firstName ?? ""} ${client?.lastName ?? ""}`.trim() || client?.alias || `Job #${jobId}` || "Client";

  const sourceEvent = arg.event.extendedProps?.event;
  const startTime = sourceEvent?.startDate ? formatCompanyInstant(sourceEvent.startDate, companyTimeZone) : (start ? formatDate(start.toISOString(), companyTimeZone, "h:mm a") : "");
  const endTime = sourceEvent?.endDate ? formatCompanyInstant(sourceEvent.endDate, companyTimeZone) : (end ? formatDate(end.toISOString(), companyTimeZone, "h:mm a") : null);

  const shortStatus =
    status
      ?.replace(/[-_]/g, " ")
      .split(" ")
      .map((w) => w[0]?.toUpperCase())
      .join("") || "ST";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.45,
        height: "18px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        fontSize: "0.58rem",
      }}
    >
      <FiberManualRecordIcon
        sx={{
          fontSize: 8,
          color: palette.color,
          flexShrink: 0,
        }}
      />

      <Box sx={{ fontWeight: 700, color: palette.color, flexShrink: 0 }}>{shortStatus}</Box>

      <Box
        sx={{
          fontWeight: 700,
          color: "var(--fx-surface-textsecondary, #64748B)",
          flexShrink: 0,
        }}
      >
        #{jobId}
      </Box>

      <Box
        sx={{
          maxWidth: "70px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontWeight: 600,
          color: "var(--fx-surface-textsecondary, #64748B)",
        }}
      >
        {clientName}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.15,
          flexShrink: 0,
          color: "var(--fx-surface-textsecondary, #64748B)",
        }}
      >
        <AccessTimeIcon sx={{ fontSize: 8 }} />
        {endTime ? `${startTime}-${endTime}` : startTime}
      </Box>
    </Box>
  );
};
